import React from "react";
import { Modal } from "react-bootstrap";
import * as Yup from "yup";
import CustomInput from "../../../custom-input/CustomInput";
import { useFormik } from "formik";

type Props = {
  show: boolean;
  onHide: () => void;
  handleCreateLabel: (e: string) => void;
};

function LabelManager({ show, onHide, handleCreateLabel }: Props) {
  const initialValues = {
    label_name: "",
  };

  const validationSchema = Yup.object().shape({
    label_name: Yup.string().required("Label name is required"),
  });

  const formik: any = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values: any) => {
      handleCreateLabel(values?.label_name);
    },
  });
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Create New Label</Modal.Title>
      </Modal.Header>
      <form className="row" onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <div className="p-2">
            <CustomInput
              label="Label Name"
              fieldName="label_name"
              type="text"
              formik={formik}
              key="label_name"
              required
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="modal-primary-button modal-secondary-button"
            onClick={onHide}
          >
            Close
          </button>
          <button className="modal-primary-button">Create Label</button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default LabelManager;
